import { Column, FileStorage } from "src/api/types";
import format from "date-fns/format";

export const columns: readonly Column<FileStorage>[] = [
  {
    id: "title",
    label: "Plan Type",
    minWidth: 50,
    orderable: false,
    format: (plan) => plan.title,
    align: "center",
  },
  {
    id: "status",
    label: "Status",
    minWidth: 50,
    orderable: false,
    format: (plan) => plan.status,
    align: "center",
  },
  {
    id: "month",
    label: "Month",
    minWidth: 50,
    orderable: false,
    format: (plan) => plan.month,
    align: "center",
  },
  {
    id: "year",
    label: "Year",
    minWidth: 50,
    orderable: false,
    format: (plan) => plan.year,
    align: "center",
  },
  {
    id: "created_at",
    label: "Date Uploaded",
    minWidth: 60,
    orderable: false,
    format: (plan) => format(new Date(plan.created_at || ""), "MM/dd/yyyy"),
    align: "center",
  },
  {
    id: "uploaded_by",
    label: "Uploaded By",
    minWidth: 60,
    orderable: false,
    format: (plan) => plan.uploaded_by,
    align: "center",
  },
  {
    id: "language",
    label: "Language",
    minWidth: 50,
    orderable: false,
    format: (plan) => plan.language,
    align: "center",
  },
];
